(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 768px)');
  const saved = new Map();
  let nav, wrapper, observer, frame, header;
  let gesture = null, lastTouch = null;
  function touchStart(event) {
    if (!mobile.matches) return;
    event.stopPropagation();
    lastTouch = null;
    if (event.touches.length !== 1) {
      if (gesture) gesture.moved = true;
      return;
    }
    const point = event.touches[0];
    const scroller = event.target.closest('.nav-menu') || wrapper;
    gesture = {
      id: point.identifier,
      x: point.clientX,
      y: point.clientY,
      started: performance.now(),
      scroller,
      scrollTop: scroller.scrollTop,
      moved: false
    };
  }
  function touchMove(event) {
    if (!gesture) return;
    const point = Array.from(event.touches).find(t => t.identifier === gesture.id);
    if (event.touches.length !== 1 || !point ||
      Math.hypot(point.clientX - gesture.x, point.clientY - gesture.y) > 10)
      gesture.moved = true;
  }
  function touchEnd(event) {
    if (!gesture) return;
    const point = Array.from(event.changedTouches).find(t => t.identifier === gesture.id);
    if (!point && event.type !== 'touchcancel') return;
    const now = performance.now();
    lastTouch = {
      ended: now,
      blocked: event.type === 'touchcancel' || gesture.moved ||
        now - gesture.started > 700 ||
        Math.abs(gesture.scroller.scrollTop - gesture.scrollTop) > 2 ||
        (point && Math.hypot(point.clientX - gesture.x, point.clientY - gesture.y) > 10)
    };
    gesture = null;
  }
  function attr(el, key, value) {
    if (!saved.has(el)) saved.set(el, new Map());
    const original = saved.get(el);
    if (!original.has(key)) original.set(key, el.getAttribute(key));
    if (value === null) el.removeAttribute(key);
    else if (el.getAttribute(key) !== String(value)) el.setAttribute(key, value);
  }
  function sync() {
    frame = 0;
    if (!mobile.matches || !nav) return;
    const close = wrapper.querySelector('.nav-menus-wrapper-close-button');
    if (close) {
      attr(close, 'role', 'button');
      attr(close, 'tabindex', '0');
      attr(close, 'aria-label', 'Close menu');
    }
    nav.querySelectorAll('.nav-menu > li').forEach((item, i) => {
      const link = item.querySelector(':scope > a');
      const panel = item.querySelector(':scope > .megamenu-panel');
      if (!link) return;
      if (panel) {
        attr(panel, 'id', panel.id || 'cz-mobile-menu-panel-' + i);
        attr(link, 'role', 'button');
        attr(link, 'aria-controls', panel.id);
        attr(link, 'aria-expanded', item.classList.contains('focus'));
      } else if (link.textContent.trim() === 'Sale!') {
        attr(link, 'data-cz-menu-sale', '');
      }
    });
    nav.querySelectorAll('.mm-list .tablinks').forEach((button, i) => {
      const panel = button.nextElementSibling;
      if (!panel || !panel.classList.contains('megamenu_child_mob')) return;
      const firstVisit = !saved.get(panel)?.has('class');
      attr(button, 'class', button.className);
      attr(panel, 'class', panel.className);
      if (firstVisit) {
        button.classList.remove('select_mm_c_item');
        panel.classList.remove('show_mm_c_item');
      }
      attr(button, 'type', 'button');
      attr(panel, 'id', 'cz-mobile-menu-child-' + i);
      attr(button, 'aria-controls', panel.id);
      attr(button, 'aria-expanded', panel.classList.contains('show_mm_c_item'));
    });
    const bottom = document.querySelector('.cz-mobile-bottom-nav');
    const height = bottom && bottom.getBoundingClientRect().height;
    if (height) {
      const value = Math.ceil(height) + 'px';
      if (wrapper.style.getPropertyValue('--cz-menu-bottom') !== value)
        wrapper.style.setProperty('--cz-menu-bottom', value);
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(sync);
  }
  function click(event) {
    if (!mobile.matches) return;
    const touchClick = event.pointerType === 'touch' ||
      event.sourceCapabilities?.firesTouchEvents ||
      (!event.pointerType && !event.sourceCapabilities);
    if (event.detail > 0 && touchClick && lastTouch?.blocked &&
      performance.now() - lastTouch.ended < 800) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    lastTouch = null;
    const parentLink = event.target.closest('.nav-menu > li > .mm_parent_link');
    if (parentLink && nav.contains(parentLink) &&
      !parentLink.parentElement.classList.contains('focus')) {
      parentLink.parentElement.querySelectorAll('.mm-list .tablinks').forEach(childButton => {
        const childPanel = childButton.nextElementSibling;
        if (!childPanel || !childPanel.classList.contains('megamenu_child_mob')) return;
        attr(childButton, 'class', childButton.className);
        attr(childPanel, 'class', childPanel.className);
        childButton.classList.remove('select_mm_c_item');
        childPanel.classList.remove('show_mm_c_item');
        attr(childButton, 'aria-expanded', 'false');
      });
    }
    const button = event.target.closest('.mm-list .tablinks');
    if (!button || !nav.contains(button)) return;
    const panel = button.nextElementSibling;
    if (!panel || !panel.classList.contains('megamenu_child_mob')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const wasOpen = panel.classList.contains('show_mm_c_item');
    button.closest('.mm-list').querySelectorAll('.tablinks').forEach(sibling => {
      const child = sibling.nextElementSibling;
      sibling.classList.remove('select_mm_c_item');
      if (child && child.classList.contains('megamenu_child_mob'))
        child.classList.remove('show_mm_c_item');
    });
    if (!wasOpen) {
      button.classList.add('select_mm_c_item');
      panel.classList.add('show_mm_c_item');
    }
    sync();
  }
  function keydown(event) {
    if (!mobile.matches) return;
    const target = event.target;
    if (event.key === 'Escape' && wrapper.classList.contains('nav-menus-wrapper-open')) {
      wrapper.querySelector('.nav-menus-wrapper-close-button')?.click();
      document.querySelector('[data-cz-action="menu"]')?.focus();
    } else if ((event.key === ' ' && target.matches('.mm_parent_link[role="button"]')) ||
      ((event.key === 'Enter' || event.key === ' ') && target.matches('.nav-menus-wrapper-close-button'))) {
      event.preventDefault();
      target.click();
    }
  }
  function disable() {
    observer?.disconnect();
    observer = null;
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    nav?.removeEventListener('click', click, true);
    nav?.removeEventListener('touchstart', touchStart, true);
    nav?.removeEventListener('touchmove', touchMove, true);
    nav?.removeEventListener('touchend', touchEnd, true);
    nav?.removeEventListener('touchcancel', touchEnd, true);
    nav?.removeEventListener('keydown', keydown);
    gesture = lastTouch = null;
    header?.remove();
    header = null;
    nav?.classList.remove('cz-mobile-menu');
    wrapper?.style.removeProperty('--cz-menu-bottom');
    saved.forEach((attributes, el) => attributes.forEach((value, key) => {
      if (value === null) el.removeAttribute(key);
      else el.setAttribute(key, value);
    }));
    saved.clear();
  }
  function init() {
    const current = document.querySelector('#navigation1');
    if (!mobile.matches) { disable(); return; }
    if (nav === current && observer) { schedule(); return; }
    disable();
    nav = current;
    wrapper = nav?.querySelector('.nav-menus-wrapper');
    if (!wrapper) return;
    const source = document.querySelector('.site-header__logo-link:not(.logo--inverted) img');
    if (source) {
      header = document.createElement('div');
      header.className = 'cz-mobile-menu-header';
      const link = document.createElement('a');
      link.href = source.closest('a').href;
      link.className = 'cz-mobile-menu-logo';
      const logo = document.createElement('img');
      logo.src = source.currentSrc || source.src;
      logo.alt = source.alt || 'CARZILLA';
      logo.width = source.naturalWidth || 340;
      logo.height = source.naturalHeight || 72;
      logo.decoding = 'async';
      link.append(logo);
      header.append(link);
      wrapper.insertBefore(header, wrapper.querySelector('.nav-menu'));
    }
    nav.classList.add('cz-mobile-menu');
    nav.addEventListener('click', click, true);
    nav.addEventListener('touchstart', touchStart, { capture: true, passive: true });
    nav.addEventListener('touchmove', touchMove, { capture: true, passive: true });
    nav.addEventListener('touchend', touchEnd, { capture: true, passive: true });
    nav.addEventListener('touchcancel', touchEnd, { capture: true, passive: true });
    nav.addEventListener('keydown', keydown);
    observer = new MutationObserver(schedule);
    observer.observe(nav, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    sync();
  }
  mobile.addEventListener('change', init);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

